module.exports = __webpack_public_path__ + "static/media/sample-activity-report-aus.6b37274b.pdf";